import { useEffect } from 'react';

export type Detail = {
  action: string;
  event: string;
  [key: string]: boolean | string;
};
export type ConsentEvent = CustomEvent<Detail>;
type EventHandler = (event: ConsentEvent) => void;

export function useUserCentricsConsentEvent(eventHandler: EventHandler) {
  useEffect(() => {
    const onUcEvent = eventHandler as EventListener;

    window.addEventListener('ucEvent', onUcEvent);
    return () => {
      window.removeEventListener('ucEvent', onUcEvent);
    };
  }, [eventHandler]);
}
